import React from "react";
import './About.css';
import nimraImage from '../images/nimra-khan.jpg';  // Correct import path

const About = () => {
  return (
    <div className="about">
      <h2>About Me</h2>
      <div className="profile">
        <img src={nimraImage} alt="Nimra Khan" className="profile-img" />
        <div className="profile-content">
          <h3>Nimra Khan</h3>
          <p><strong>Software Engineer</strong></p>
          <p>
            Hello! I’m Nimra Khan, a passionate Software Engineer with a love for web development. 
            I specialize in front-end technologies like React, CSS, and JavaScript. I love creating 
            beautiful, responsive, and user-friendly applications.
          </p>
          <p>
            I am constantly exploring new technologies and improving my skills. You can check out my 
            blog posts where I share my journey, tutorials, and tips on web development.
          </p>
          
          <div className="social-links">
            <a href="https://www.linkedin.com/in/nimra-khan-570ab9312/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://www.instagram.com/nimra__offical/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://github.com/Nimra-khan1" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-github"></i>
            </a>
            <a href="mailto:nk4721006@gmail.com" target="_blank" rel="noopener noreferrer">
              <i className="fas fa-envelope"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
